const actionScope = '[Company Login SSO]';

export class LoadSsoStatus {
  static readonly type = `${actionScope} Load Sso Status`;

  constructor(
    public organizationName: string,
    public trackingId: string
  ) {}
}
